import React from 'react'
import PropTypes from 'prop-types';
import { connect } from 'react-redux'
import TeamImage from './TeamImage.png'
import {HeaderView} from '../HeaderView/HeaderView'
import {FooterLinks} from '../FooterLinks/FooterLinks'
import {SocialView} from '../SocialView/SocialView'
import {FooterNote} from '../FooterLinks/FooterNote'
import {fetchMenusIfNeeded} from '../../actions'

export class PresentationView extends React.Component {

  drawBackgroundImage () {
    return {
      backgroundImage: `url('${TeamImage}')`
    }
  }

  componentDidMount () {
    const {dispatch} = this.props
    dispatch(fetchMenusIfNeeded(this.props.selectedScope))
  }

  componentWillReceiveProps (nextProps) {
    const {selectedScope, dispatch} = nextProps
    if (selectedScope !== this.props.selectedScope) {
      dispatch(fetchMenusIfNeeded(selectedScope))
    }
  }

  render () {
    const {menus, dispatch} = this.props
    const bottom_menus = menus.bottom || []
    const top_menus = menus.top || []

    return (
      <div>
        <HeaderView top_menus={top_menus} dispatch={dispatch}/>
        <div id='presentation-view' className='row team-view'>
          <div className='col-md-12 no-pad text-left'>
            <p className='left-tag'>apresentação</p>
          </div>
          <div className='row main-block'>
            <div className='col-sm-4 col-md-4 col-lg-3  side-block no-pad'>
              <div className='thumb' style={this.drawBackgroundImage()}></div>
            </div>
            <div className='col-sm-8 col-md-offset-1 col-md-6 col-lg-5'>
              <div className='txt-block'>
                <p>8 ½ Festa do Cinema Italiano é um festival de cinema organizado pela Associação
                 Il Sorpasso em colaboração com o Instituto Italiano de Cultura e a Embaixada de Itália em Portugal.
                </p>

                <p>8 ½ já é o maior evento em Portugal dedicado ao cinema e à cultura italiana.</p>

                <p>O festival nasceu em 2008 e cresceu graças ao trabalho de uma equipa constituída
                 por profissionais portugueses e italianos: hoje encontra-se profundamente enraizado
                  na cultura e na sociedade portuguesa.
                  <br/>A sua missão é a exibição de obras que cumpram elevados critérios de qualidade,
                   sejam elas de autores consagrados ou da nova geração de cineastas, sempre fiel ao
                    objetivo de trazer à Portugal o melhor do cinema Italiano.
                </p>
                <p>Além disso, desde 2013, a Associação Il Sorpasso tem vindo a desenvolver um
                 importante trabalho na promoção do cinema italiano no mercado audiovisual português,
                  através da distribuição de filmes em diferentes formatos (cinema, televisão, dvd e
                   VoD) sob a \"marca\" 8 ½ Festa do Cinema Italiano.
                </p>
                <p>Para 2016 o festival já tem data marcadas: em Lisboa, no Cinema São Jorge e na
                 Cinemateca Portuguesa – Museu do Cinema, de 30 de março a 7 de abril e a seguir
                  marcará presença nas principais cidades portuguesas: Porto, Coimbra, Cascais,
                   Loulé, Funchal, Évora, Beja, entre outras, para depois também chegar à Mozambique,
                    Angola e Brasil!
                </p>
                <p>
                  8 ½ Festa do Cinema Italiano é um evento organizado em parceria estratégica com a
                   Câmara Municipal de Lisboa/EGEAC e em coprodução com o Cinema São Jorge e conta
                    também com o apoio do MIBACT Direção Cinema, Cinecittà Luce, e as Câmaras
                     Municipais de Lisboa, Porto, Coimbra, Loulé, Beja, Canais TVCine & Séries,
                      Generali Seguros, Liomatic Lavazza, MSC Cruzeiros, Aperol Spritz.
                </p>
              </div>
            </div>
          </div>
        </div>

        <FooterLinks bottom_menus={bottom_menus}/>
        <SocialView customclass='lite'/>
        <FooterNote />
      </div>
    )
  }
}

PresentationView.propTypes = {
  dispatch: PropTypes.func.isRequired,
  menus: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object
  ]).isRequired,
  selectedScope: PropTypes.string.isRequired
}

function mapStateToProps (state) {
  const {getMenus, selectedScope} = state

  const {
    isFetchingMenus,
    lastUpdatedMenus,
    items: menus
  } = getMenus[selectedScope] || {
    isFetchingMenus: true,
    items: {}
  }

  return {
    isFetchingMenus,
    lastUpdatedMenus,
    selectedScope,
    menus
  }
}

export default connect(mapStateToProps)(PresentationView)



// WEBPACK FOOTER //
// ./src/views/AboutView/PresentationView.js